import React from "react";
import {Primitive} from "../../../../../Types";
import {GREEN_COLOR, GREEN_LIGHT_COLOR, RED_COLOR} from "../../../../CONSTANTS";

interface PropsI {
    value: string,
    onChange: (arg: Primitive, invalid?: boolean) => void,
}

export default function RawEditBooleanInput({value, onChange}: PropsI) {

    return <button className={"btn-cmn"} onClick={() => onChange(!value)} style={{
        backgroundColor: value ? GREEN_COLOR : RED_COLOR,
        color: "black",
        fontStyle: "italic",
        fontWeight: "bold"
    }}>
        {value ? "TRUE" : "FALSE"}
    </button>

}
